import { ApiUrl } from './common/Config';
import { get, post, put } from './common/Helper';

const baseUrl = ApiUrl + 'CMS/';

export const GetAllSegments = async( token) => {
    let url = baseUrl + 'getsegments';
    return await get(url, token);
};

export const GetSegmentCourses = async( id, goal, token) => {
    let url = baseUrl + `getsegmentCourses`;
    const payload = { SegmentId: id, Goal: goal };
    return await post(url, payload, token);
};

export const GetSegmentTopics = async( id, goal, token) => {
    let url = baseUrl + `getsegmentTopics`;
    const payload = { SegmentCourseId: id, Goal: goal };
    return await post(url, payload, token);
};

export const GetSegmentAchievements = async( id, goal, token) => {
    let url = baseUrl + `getsegmentAchievements`;
    const payload = { SegmentTopicId: id, Goal: goal };
    return await post(url, payload, token);
};
export const GetSegmentCoursesInfo = async( id,token) => {
    let url = baseUrl + `getsegmentCoursesInfo?segmentId=${id}`;
    return await get(url, token);
};

export const GetSegmentTopicsInfo = async( id,token) => {
    let url = baseUrl + `getsegmentTopicsInfo?segmentCourseId=${id}`;
    return await get(url, token);
};

export const GetSegmentAchievementsInfo = async( id,token) => {
    let url = baseUrl + `getsegmentAchievementsInfo?segmentTopicId=${id}`;
    return await get(url, token);
};

export const GetWorklist = async( token) => {
    let url = baseUrl + `worklist`;
    return await get(url, token);
};
export const SetTransferJob = async( goal, token) => {
    let url = baseUrl + `settransferjob`;
    const payload = { Goal: goal };
    return await post(url, payload, token);
};